import styled from 'styled-components';

export const ExpertContainer = styled.section`
  color: #fff;
  background: #010606;
  padding: 80px 0 100px;

  @media screen and (max-width: 768px) {
    padding: 60px 0 80px;
  }
`;

export const ExpertWrapper = styled.div`
  z-index: 1;
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 24px;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 48px;
  align-items: center;

  @media screen and (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 32px;
  }
`;

export const ExpertContent = styled.div`
  max-width: 540px;
`;

export const ExpertTopLine = styled.p`
  color: #01bf71;
  font-size: 16px;
  font-weight: 700;
  letter-spacing: 1.4px;
  text-transform: uppercase;
  margin-bottom: 16px;
`;

export const ExpertHeading = styled.h2`
  font-size: 40px;
  line-height: 1.2;
  font-weight: 600;
  color: #f7f8fa;
  margin-bottom: 24px;

  @media screen and (max-width: 480px) {
    font-size: 28px;
  }
`;

export const ExpertText = styled.p`
  font-size: 18px;
  line-height: 1.6;
  color: #f0f0f0;
  margin-bottom: 32px;
`;

export const ExpertBtnWrap = styled.div`
  display: flex;
  justify-content: flex-start;
`;

export const ExpertImgWrap = styled.div`
  width: 100%;
  max-width: 480px;
  margin-left: auto;

  @media screen and (max-width: 768px) {
    margin: 0 auto;
    max-width: 100%;
  }
`;

export const ExpertImg = styled.img`
  width: 100%;
  height: auto;
  border-radius: 16px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
  display: block;
  object-fit: cover;
`;

export const ExpertImgPlaceholder = styled.div`
  width: 100%;
  aspect-ratio: 4 / 5;
  background: linear-gradient(135deg, #0d1f2d 0%, #1a3a4a 100%);
  border-radius: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #01bf71;
  font-size: 14px;
  font-weight: 600;
  text-align: center;
  line-height: 1.5;
  padding: 24px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
`;
